export function decodeHTML(str) {
    return str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
}

export function getSlug(url) {
    const segments = url.split('/');
    const slug = segments.pop() || segments.pop();
    return slug;
}
